/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "./style.css";

import amc_logo from "../../../../../assets/imgs/amc-domestico/logo_AMC.png";
import axios from "axios";
import { hiddenMedalliaButton } from "../../../light-load/components/hidemedallia";

const HeavyLoadReceptionPrimary = () => {
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [turns, setTurns] = useState([]);
  const [callTurns, setCallTurns] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    const cleanMedallia = hiddenMedalliaButton();
    return cleanMedallia;
  }, []);

  const fetchAllShifts = async () => {
    try {
      const [currentRes, nextRes, lastRes, weigher] = await Promise.all([
        axios.get(
          `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/supervisor/turn_in_progress`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "heavy-load-token"
              )}`,
            },
          }
        ),
        axios.get(
          `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/supervisor/turns_next`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "heavy-load-token"
              )}`,
            },
          }
        ),
        axios.get(
          `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/supervisor/turns_in_progress`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "heavy-load-token"
              )}`,
            },
          }
        ),
        axios.get(
          `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/supervisor/turns_without_quantity_id`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "heavy-load-token"
              )}`,
            },
          }
        ),
      ]);

      let currentTurn = [];
      let nextTurns = [];
      let lastTurns = [];
      let weigherTurns = [];

      if (currentRes.data.code === 1) {
        currentTurn = [{ ...currentRes.data.turn, type: "current" }];
      }

      // Aquí invertiste next y last, lo dejo así como está en tu versión:
      lastTurns = (nextRes.data?.turns_next || []).map((turn) => ({
        ...turn,
        type: "last",
      }));

      nextTurns = (lastRes.data?.data?.turns || []).map((turn) => ({
        ...turn,
        type: "next",
      }));

      weigherTurns = (weigher.data.turns || []).map((turn) => ({
        ...turn,
        type: "weigher",
      }));

      // Ordenar por fecha
      nextTurns.sort((a, b) => new Date(a.date) - new Date(b.date));
      lastTurns.sort((a, b) => new Date(a.date) - new Date(b.date));
      weigherTurns.sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      );

      // Seleccionar hasta 3 de 'next'
      const selectedNext = nextTurns.slice(0, 3);

      // Usar el turno actual si existe
      const selectedCurrent = currentTurn.length > 0 ? currentTurn[0] : null;

      // Calcular cuántos elementos ya tenemos
      const countNext = selectedNext.length;
      const countCurrent = selectedCurrent ? 1 : 0;
      const usedSlots = countNext + countCurrent;

      // Calcular espacios restantes
      const remainingSlots = 10 - usedSlots;

      let numLast = Math.min(remainingSlots, lastTurns.length);
      let numWeigher = remainingSlots - numLast;

      if (numWeigher > weigherTurns.length) {
        numWeigher = weigherTurns.length;
      }

      const selectedLast = lastTurns.slice(0, numLast);
      const selectedWeigher = weigherTurns.slice(0, numWeigher);

      const orderedShifts = [
        ...selectedNext, // siempre arriba
        ...(selectedCurrent ? [selectedCurrent] : []), // luego el actual
        ...selectedLast, // prioridad
        ...selectedWeigher,
      ];

      setTurns(orderedShifts);
    } catch (error) {
      console.error("Error fetching shifts:", error);
    }
  };

  function formatHour(dateString) {
    if(!dateString) {
      return "---"
    }
    const [datePart, timePart] = dateString.split(" ");
    const [day, month, year] = datePart.split("/");

    const isoFormat = `${year}-${month}-${day}T${timePart}`;

    const date = new Date(isoFormat);
    if (isNaN(date.getTime())) {
      return "---";
    }

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const arraysAreEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }

    return true;
  };

  const getTurnsVoice = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/supervisor/turn_scream`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        const newTurns = res.data.data.turns;
        if (callTurns.length === 0 || !arraysAreEqual(callTurns, newTurns)) {
          setCallTurns(newTurns);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const deletedTurnsVoice = async (id) => {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/supervisor/turn_scream/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const waitForVoices = () => {
    return new Promise((resolve) => {
      const voices = speechSynthesis.getVoices();
      if (voices.length > 0) {
        return resolve(voices);
      }

      console.log("🔄 Esperando que se carguen las voces...");

      const interval = setInterval(() => {
        const updatedVoices = speechSynthesis.getVoices();
        if (updatedVoices.length > 0) {
          clearInterval(interval);
          resolve(updatedVoices);
        }
      }, 100);
    });
  };

  const handleTextToSpeech = async (text) => {
    if (!text.trim()) {
      console.warn("⚠️ Texto vacío, se omite.");
      return;
    }

    console.log("🔊 Iniciando texto a voz:", text);

    // Cancelar cualquier voz anterior
    window.speechSynthesis.cancel();

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "es-MX"; // preferencia regional

    const voices = await waitForVoices();

    // Preferencia de voz: Raul (es-MX), cualquier es-MX, fallback a la primera disponible
    const defaultVoice =
      voices.find((v) => v.lang === "es-MX" && v.name.includes("Raul")) ||
      voices.find((v) => v.lang === "es-MX") ||
      voices[0];

    if (!defaultVoice) {
      console.error("❌ No se encontró una voz adecuada.");
      return;
    }

    utterance.voice = defaultVoice;

    return new Promise((resolve) => {
      utterance.onstart = () => console.log("▶️ Comenzó a hablar...");
      utterance.onend = () => {
        console.log("✅ Terminó de hablar.");
        resolve();
      };
      utterance.onerror = (e) => {
        console.error("❌ Error en voz:", e.error);
        resolve(); // No romper flujo
      };

      try {
        console.log(
          `🗣️ Usando voz: ${defaultVoice.name} (${defaultVoice.lang})`
        );
        window.speechSynthesis.speak(utterance);
      } catch (e) {
        console.error("❌ Excepción al hablar:", e);
        resolve();
      }
    });
  };

  useEffect(() => {
    fetchAllShifts();

    const interval = setInterval(fetchAllShifts, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(getTurnsVoice, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    function getFormattedDate() {
      const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ];

      const now = new Date();
      const dayName = days[now.getDay()];
      const day = now.getDate();
      const monthName = months[now.getMonth()];
      const year = now.getFullYear();

      return `${dayName}, ${day} de ${monthName} ${year}`;
    }

    function getFormattedTime() {
      const now = new Date();
      let hours = now.getHours(); // Mantén las horas tal cual están en formato de 24 horas
      const minutes = now.getMinutes().toString().padStart(2, "0");

      // Devuelve el tiempo en formato 24 horas
      return `${hours}:${minutes}`;
    }

    const interval = setInterval(() => {
      setCurrentDate(getFormattedDate());
      setCurrentTime(getFormattedTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const processTurns = async () => {
      console.log("🚦 Procesando turnos para vocear:", callTurns);
      if (isProcessing) return;
      setIsProcessing(true);

      for (const turn of callTurns) {
        try {
          const number = parseInt(turn.turn_number, 10).toString();
          const message = `Turno ${number} por favor dirigirse a ${turn.counter_checkout_name}`;

          console.log("📢 Llamando turno:", message);

          await handleTextToSpeech(message);

          const deleteSuccess = await deletedTurnsVoice(turn.id);
          if (deleteSuccess) {
            console.log(`🗑️ Turno ${turn.id} eliminado exitosamente`);
            setCallTurns((prevTurns) =>
              prevTurns.filter((t) => t.id !== turn.id)
            );
          } else {
            console.error(`❌ Error al eliminar el turno con ID: ${turn.id}`);
          }
        } catch (error) {
          console.error(`❌ Error procesando turno ${turn.id}:`, error);
        }
      }

      setIsProcessing(false);
    };

    if (callTurns.length > 0 && !isProcessing) {
      processTurns();
    }
  }, [callTurns, isProcessing]);

  return (
    <>
      <div className="reception-container">
        <div className="reception-banner">
          <div className="banner-header">
            <div className="header-image">
              <img src={amc_logo} alt="amc-logo" />
            </div>
            <div className="header-hours">
              <span>{currentDate}</span>
              <span>{currentTime}</span>
            </div>
          </div>
          <div className="banner-body">
            <video
              src="https://dyn-pwc-ac.amlab7.com/pantalla-turnos-video-v2.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="banner-video"
            />
          </div>
        </div>
        <div className="reception-turns">
          <div className="turns-body">
            <div className="next-shifts">
              <div className="tabla">
                <div className="tabla-header">
                  <div className="header-cell">Turno</div>
                  <div className="header-cell">Mostrador</div>
                  <div className="header-cell">Inicio</div>
                  <div className="header-cell">Pesaje</div>
                </div>
                {turns.length === 0 ? (
                  <p
                    style={{
                      marginTop: "10vh",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    No hay turnos por mostrar
                  </p>
                ) : (
                  <>
                    {turns.slice(0, 11).map((item, index) => {
                      const checkoutName = item.counter_checkout_name
                        ? item.counter_checkout_name.replace("Mostrador ", "")
                        : "-";

                      return (
                        <div className="tabla-row" key={index}>
                          <div
                            className={`cell ${
                              item.type === "current" ? "current-turn" : ""
                            } ${item.type === "next" ? "next-turn" : ""} ${
                              item.type === "last" ? "last-turn" : ""
                            } ${item.type === "weigher" ? "weigher-turn" : ""}`}
                          >
                            {item.turn_number}
                          </div>
                          <div
                            className={`cell ${
                              item.type === "current" ? "current-turn" : ""
                            } ${item.type === "next" ? "next-turn" : ""} ${
                              item.type === "last" ? "last-turn" : ""
                            } ${item.type === "weigher" ? "weigher-turn" : ""}`}
                          >
                            {checkoutName}
                          </div>
                          <div
                            className={`cell ${
                              item.type === "current" ? "current-turn" : ""
                            } ${item.type === "next" ? "next-turn" : ""} ${
                              item.type === "last" ? "last-turn" : ""
                            } ${item.type === "weigher" ? "weigher-turn" : ""}`}
                          >
                            {formatHour(item.created_at ?? item.date) ===
                            "Fecha inválida"
                              ? "-"
                              : formatHour(item.created_at ?? item.date)}
                          </div>
                          <div
                            className={`cell ${
                              item.type === "current" ? "current-turn" : ""
                            } ${item.type === "next" ? "next-turn" : ""} ${
                              item.type === "last" ? "last-turn" : ""
                            } ${item.type === "weigher" ? "weigher-turn" : ""}`}
                          >
                            {"updated_at" in item
                              ? formatHour(item?.updated_at) ===
                                "Fecha inválida"
                                ? "-"
                                : formatHour(item?.updated_at)
                              : "-"}
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            </div>
            <div className="hl-turns-body-messages">
              <h1>Orden de turno conforme a inspección</h1>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeavyLoadReceptionPrimary;
